// "Play here instead" screen. Shown when another window / device is the active one for this account: this window has stopped
// saving (so it can't overwrite the other's progress) and asks the player to choose. See accountManager.blockSession().
import { Events, on } from './eventBus.js'
import { takeOver } from '../game/accountManager.js'

export function mountSessionBlocked() {
  const el = document.createElement('div')
  el.className = 'session-blocked'
  el.setAttribute('role', 'alertdialog')
  el.innerHTML = `
    <div class="session-blocked__card">
      <div class="session-blocked__title">Mao Kingdom is open somewhere else</div>
      <p class="session-blocked__msg" data-msg></p>
      <button class="session-blocked__btn" type="button" data-take>Play here instead</button>
      <p class="session-blocked__fine">Your progress is safe. Switching loads your latest saved game here.</p>
    </div>`
  document.body.appendChild(el)
  const msg = el.querySelector('[data-msg]')
  const btn = el.querySelector('[data-take]')
  on(Events.SessionBlocked, ({ reason }) => {
    msg.textContent = reason === 'device'
      ? 'Your game was just played on another device or window. To keep your progress and any coins you bought from getting mixed up, only one can play at a time.'
      : 'Your game is already open in another window. To keep your progress and any coins you bought from getting mixed up, only one window can play at a time.'
    el.classList.add('on')
  })
  btn.addEventListener('click', () => { btn.disabled = true; btn.textContent = 'Switching…'; takeOver() })
}
